<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="districtList"
                border
                style="width: 100%"
                ref="multipleTable"
                row-key="id"
                :cell-class-name="cell"
              >
                <el-table-column prop="districtNameEn" label="District Name">
                </el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                    v-if="
                        checkPermission('school_contact_us_detail') 
                      "
                      size="mini"
                      @click="handleDbClick(scope.row)"
                      icon="el-icon-edit"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";


export default {
  mixins: [config.globalMixin],
  data() {
    return {
      districtList: [],
    };
  },
  components: {
  },
  created() {
    this.getDistrictList();
  },
  computed:{
    total(){
      return this.districtList.length
    }
  },
  methods: {
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/schoolContactUsDetail",
        query: {
          id: row.id,
        },
      });
    },
    async getDistrictList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtList", data.data.result);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
